import { render, staticRenderFns } from "./ContactFormBasic.vue?vue&type=template&id=6c7bdb96&"
import script from "./ContactFormBasic.vue?vue&type=script&lang=js&"
export * from "./ContactFormBasic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports